import { Component, input, output } from '@angular/core';
import { RaEditTooltipDirective } from '../../directives/ra-edit-tooltip/ra-edit-tooltip.directive';

const HEX_COLOR = /^#[0-9a-f]{6}$/;

/**
 * Bolinha arco-íris da cor livre: o seletor nativo de cor dentro de um círculo, ao lado das
 * cores prontas. Serve o fundo da mídia (media-fill-field) e a cor do destaque, dos
 * indicadores e da tabela (menus do rail).
 *
 * Emite `preview` enquanto o seletor é arrastado (quem usa mostra na hora, sem salvar) e
 * `choose` quando ele fecha (quem usa salva). Sempre `#rrggbb` em minúsculas.
 */
@Component({
    selector: 'custom-color-swatch',
    templateUrl: 'custom-color-swatch.component.html',
    styleUrl: 'custom-color-swatch.component.scss',
    imports: [RaEditTooltipDirective],
})
export class CustomColorSwatchComponent {
    /** Valor inicial do seletor, #rrggbb (ele não entende outro formato). */
    public value = input.required<string>();
    /** A cor em uso é a livre: o anel acende. */
    public current = input(false);
    public disabled = input(false);
    /** Nome acessível e dica (já traduzidos). */
    public label = input.required<string>();

    public preview = output<string>();
    public choose = output<string>();

    public onInput(event: Event): void {
        const color = parseHex((event.target as HTMLInputElement).value);
        if (color !== null) this.preview.emit(color);
    }

    /** O seletor fechou: quem usa salva já. */
    public onChange(event: Event): void {
        const color = parseHex((event.target as HTMLInputElement).value);
        if (color !== null) this.choose.emit(color);
    }
}

function parseHex(raw: string): string | null {
    const color = raw.trim().toLowerCase();
    return HEX_COLOR.test(color) ? color : null;
}
